import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface PickupCheckProps {
    schedule: ScheduleItem[];
    showModal: boolean;
    hideModal(): void;
    cancel(): void;
    save(): void;
}

interface ScheduleItem {
    origItemIndex: number;  //index from pickup/install list - if set means we have scheduled and unscheduled without saving
    itemIndex: number;
    id: number;
    jobId: number;
    itemId: number;
    item: string;
    jobQuoteItemId: number;
    type: string;
    typeId: number;
    hirePeriodActual: number;
    hirePeriod: string;
    siteAddress: string;
    status: string;
    quantityTotal: number;
    quantityScheduled: number;
    scheduledDate: string;
    installationDate: string;
    onhireDate: string;
    offhireDate: string;
    pickupDate: string;
    paid: boolean;
    goAhead: boolean;
    accountTypeId: number;
    allowOnGoingHire: number;
    chargePublicHoliday: boolean;
    chargeShutdownPeriod: boolean;
    purchaseOrderNumber: string;
    showRedNotes: boolean;
    pickupScheduled: boolean;
    callout: boolean;
    copy: boolean;
    isDirty: boolean;
}

interface PickupCheckModal {
    loading: boolean;
}

export default class SchedulePickupCheckModal extends React.Component<PickupCheckProps, PickupCheckModal> {
    constructor(props: PickupCheckProps) {
        super(props);
        this.state = {
            loading: false
        }
    }

    hideModal = () => {
        this.props.hideModal();
    }

    cancel = () => {
        this.props.cancel();
    }

    save = (e: any) => {
        e.preventDefault();

        this.props.save();
    }

    formatDate = (dateToFormat: any) => {
        //var date = new Date();
        var date = new Date(dateToFormat);
        var currentMonth = (date.getMonth() + 1);
        var month = currentMonth < 10 ? "0" + currentMonth : currentMonth;
        var currentDay = date.getDate();
        var day = currentDay < 10 ? "0" + currentDay : currentDay;

        return day + "/" + month + "/" + date.getFullYear();
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let schedule = this.props.schedule;

        return (
            <div className="static-modal">
                <Modal size="lg" show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Check Offhire and Pickup Dates</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <span>Are the following Offhire and Pickup dates correct?</span>
                        <div className="table__margin overflowAuto">
                            <table className="table tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th>Item</th>
                                        <th>Hire Period</th>
                                        <th>Address</th>
                                        <th>Offhire Date</th>
                                        <th>Pickup Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {schedule.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td className="table__text--align"> {item.item}</td>
                                            <td className="table__text--align">{item.hirePeriod}</td>
                                            <td className="table__text--align">
                                                <div className="tooltipitem tooltipitem__right">{item.siteAddress ? item.siteAddress.substring(0, 30) + "... " : ""}
                                                    <span className="tooltipitemtext tooltipitemtext__right">{item.siteAddress}</span>
                                                </div>
                                            </td>
                                            <td className="table__text--align">{this.formatDate(item.offhireDate)}</td>
                                            <td className="table__text--align">{this.formatDate(item.pickupDate)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--no" onClick={this.cancel}>No (Cancel Save)</button>
                        <button className="popup-button--yes" onClick={this.save}>Yes (Save)</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }



}